export default __webpack_public_path__ + "static/media/crazy.5b14583f.svg";